/* tslint:disable */
/* eslint-disable */
export enum RemitUnderpaymentToleranceType {
  Percentage = 1,
  DollarAmount = 2
}
